import { fetch } from 'wix-fetch';

export function getUserDetails() {
	return fetch("https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails", { "method": "get" })
		.then((httpResponse) => {
			if (httpResponse.ok) {
				return httpResponse.json();
			}
			return Promise.reject("Fetch did not succeed");
		})
		.then((json) => {
			if (json.success && json.payload && json.payload.guid) {
				return { guid: json.payload.guid, email: json.payload.email };
			}
		})
		.catch((err) => {
			console.log("could not get user details");
		});
}



